import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppCustomStyles } from "../../../assets/theme/custom/hooks";
import { AppButton } from "../../../components/form";
import PrepDesignActionsMenu from "./PrepDesignActionsMenu";

type Props = {
  saving: boolean;
  running: boolean;
  jobId: string | null;
  onAddDsl: () => void;
  onAddAdaptor: () => void;
  onAddOpenApi: () => void;
  onAutoLayout: () => void;
  onSave: () => void;
  onValidate: () => void;
  onPreviewChain: () => void;
  onPublish: () => void;
  onRun: () => void;
  onViewRuns: () => void;
  onOpenAnalysis: () => void;
  onGenerateAnalysis: () => void;
  onDeleteJob: () => void;
};

export default function PrepDesignToolbar({
  saving,
  running,
  jobId,
  onAddDsl,
  onAddAdaptor,
  onAddOpenApi,
  onAutoLayout,
  onSave,
  onValidate,
  onPreviewChain,
  onPublish,
  onRun,
  onViewRuns,
  onOpenAnalysis,
  onGenerateAnalysis,
  onDeleteJob,
}: Props) {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();

  return (
    <Paper variant="outlined" sx={custom.components.dataPrep.toolbarPaper}>
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" flexWrap="wrap" useFlexGap>
        <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap alignItems="center">
          <AppButton
            size="small"
            variant="contained"
            color="primary"
            startIcon={<PostAddOutlinedIcon />}
            onClick={onAddDsl}
          >
            {t("prep.design.addDsl")}
          </AppButton>
          <AppButton
            size="small"
            variant="contained"
            color="primary"
            startIcon={<PostAddOutlinedIcon />}
            onClick={onAddAdaptor}
          >
            {t("prep.design.addAdaptor")}
          </AppButton>
          <AppButton
            size="small"
            variant="contained"
            color="primary"
            startIcon={<PostAddOutlinedIcon />}
            onClick={onAddOpenApi}
          >
            {t("prep.design.addOpenApi")}
          </AppButton>
          <AppButton
            size="small"
            variant="outlined"
            color="primary"
            startIcon={<AccountTreeOutlinedIcon />}
            onClick={onAutoLayout}
          >
            {t("prep.design.autoLayout")}
          </AppButton>
          <AppButton
            size="small"
            variant="contained"
            color="primary"
            startIcon={<SaveOutlinedIcon />}
            onClick={onSave}
            disabled={saving}
          >
            {t("common.save")}
          </AppButton>
        </Stack>

        <PrepDesignActionsMenu
          jobId={jobId}
          running={running}
          onValidate={onValidate}
          onPreviewChain={onPreviewChain}
          onGenerateAnalysis={onGenerateAnalysis}
          onOpenAnalysis={onOpenAnalysis}
          onPublish={onPublish}
          onRun={onRun}
          onViewRuns={onViewRuns}
          onDeleteJob={onDeleteJob}
        />
      </Stack>
    </Paper>
  );
}
